<!--往届回顾-->
<template>
  <div>
    <div class="selectMenu" ref="selectMenuBox">
      <h3 ref="selectMenuH3" @click="selectMenuH3View">
        <b class="ellipsisMultiline" style="width:5.6rem">{{
          selectMenu.text
        }}</b>
        <span>
          筛选
          <van-icon name="arrow-down" size=".3rem" />
        </span>
      </h3>
      <ul ref="selectMenuContent">
        <li
          v-for="(item, index) in selectMenuOption"
          :key="index"
          @click="selectMenuView(item.value)"
          :class="selectMenu.value == item.value ? 'selectStyle' : ''"
        >
          <span class="ellipsisMultiline">{{ item.text }}</span>
          <van-icon
            name="success"
            size=".3rem"
            v-show="selectMenu.value == item.value"
          />
        </li>
      </ul>
    </div>
    <div id="content">
      <ul>
        <li v-for="(item, index) in contentListData" :key="index">
          <img :src="item.icon" alt />
          <span>{{ item.title }}</span>
          <van-icon name="arrow" class="arrow-right" />
        </li>
      </ul>
    </div>
    <van-overlay :show="selectMenuShow" @click="selectMenuH3View" z-index="1" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectMenuShow: false,
      selectMenu: {
        value: 5,
        text: '第五届服贸会'
      },
      selectMenuOption: [
        { text: '第五届服贸会', value: 5 },
        { text: '第四届服贸会', value: 4 },
        {
          text: '第三届服贸会大会上空间大数据都是垃圾的老师讲道理圣诞节',
          value: 3
        },
        { text: '第二届服贸会', value: 2 },
        { text: '第一届服贸会', value: 1 }
      ],
      contentListData: [
        {
          icon: require('../../../assets/img-m/review/icon-xmqt.png'),
          title: '项目洽谈'
        },
        {
          icon: require('../../../assets/img-m/review/icon-hyjl.png'),
          title: '会议交流'
        },
        {
          icon: require('../../../assets/img-m/review/icon-hyzb.png'),
          title: '会议直播'
        },
        {
          icon: require('../../../assets/img-m/review/icon-hyrc.png'),
          title: '会议日程'
        },
        {
          icon: require('../../../assets/img-m/review/icon-zsml.png'),
          title: '展商名录'
        },
        {
          icon: require('../../../assets/img-m/review/icon-cbjg.png'),
          title: '承办机构'
        },
        {
          icon: require('../../../assets/img-m/review/icon-zqtc.png'),
          title: '展区图册'
        }
      ]
    }
  },
  methods: {
    selectMenuH3View() {
      this.selectMenuShow = !this.selectMenuShow
      let allH = this.$refs.selectMenuBox.offsetHeight
      let titleH = this.$refs.selectMenuH3.offsetHeight
      let contentH = this.$refs.selectMenuContent.offsetHeight
      if (allH > titleH) {
        this.$refs.selectMenuBox.style.height = titleH + 'px'
        this.$refs.selectMenuBox.style.transition = 'height .2s'
      } else {
        this.$refs.selectMenuBox.style.height = titleH + contentH + 'px'
        this.$refs.selectMenuBox.style.transition = 'height .2s'
      }
    },
    selectMenuView(val) {
      this.selectMenuOption.forEach(element => {
        if (element.value == val) {
          this.selectMenu = element
        }
      })
      this.selectMenuH3View()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.selectMenu {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 0.9rem;
  line-height: 0.9rem;
  overflow: hidden;
  background: #fff;
  .ellipsisMultiline {
    width: 6rem;
    float: left;
    @include ellipsisMultiline();
  }
  h3 {
    padding-left: 0.3rem;
    font-size: 0.3rem;
    color: #333;
    border-bottom: 1px solid $borderColor;
    overflow: hidden;
    b {
      font-weight: 600;
    }
    span {
      color: #666;
      float: right;
      margin-right: 0.3rem;
    }
    v-deep.van-icon {
      padding-left: 0.02rem;
      position: relative;
      top: 0.03rem;
    }
  }
  ul {
    width: 100%;
    background: #fafbfd;
    max-height: 4.5rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    li {
      width: 7rem;
      margin: 0 auto;
      font-size: 0.3rem;
      height: 0.9rem;
      line-height: 0.9rem;
      padding-left: 0.05rem;
      border-bottom: 1px solid $borderColor;
      overflow: hidden;
      &.selectStyle {
        color: $themeColor;
      }
      &:last-of-type {
        border: 0;
      }
      v-deep.van-icon {
        float: right;
        margin-right: 0.1rem;
        display: block;
        height: 0.9rem;
        line-height: 0.9rem;
      }
    }
  }
}
#content {
  margin-top: 1.1rem;
  > ul {
    li {
      width: 6.9rem;
      height: 1.3rem;
      line-height: 1.3rem;
      background: #fff;
      border-radius: 0.2rem;
      margin: 0.2rem auto;
      display: flex;
      display: -webkit-flex;

      font-size: 0.32rem;
      color: #333;
      font-weight: 600;
      img {
        display: block;
        width: 0.68rem;
        margin: 0.3rem;
      }
      span {
        flex: 1;
        -webkit-flex: 1;
        @include ellipsisMultiline();
      }
      .arrow-right {
        width: 0.5rem;
        line-height: 1.3rem;
      }
    }
  }
}
</style>
